import React, { useState, useEffect } from 'react';
import { Box, theme } from '@xometry/xometry_loft';
import OrganizationRoleColors from './OrganizationRoleStaticData';

const UserInitial = (props) => {
  const { fullName, role, size } = props;
  const [userInitial, setUserInitial] = useState('');
  useEffect(() => {
    if (fullName) {
      const [firstName, lastName] = fullName
        .replace(/[^\w\s]/gi, '')
        .split(' ')
        .filter((n) => n);
      if (!lastName && firstName?.length < 2) {
        setUserInitial(firstName[0] || '');
      } else {
        const fullNameInitial = `${firstName[0]}${
          lastName ? lastName[0] : firstName[1]
        }`;
        setUserInitial(fullNameInitial || ' ');
      }
    } else {
      setUserInitial('');
    }
  }, [fullName]);

  return (
    <Box
      style={{
        background: `${
          OrganizationRoleColors[role.toLocaleLowerCase()] ||
          theme.colors.darkBlues[75]
        }`,
        color: `${
          role.toLocaleLowerCase() !== 'creator' && theme.colors.white
        }`,
        minWidth: `${size}px`,
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '3px',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        fontWeight: `${theme.fontWeights.semibold}`,
      }}
    >
      {userInitial}
    </Box>
  );
};
export default UserInitial;
